import { datadogLogs } from "@datadog/browser-logs"

if (window.datadogSettings?.clientToken) {
  datadogLogs.init({
    clientToken: window.datadogSettings.clientToken,
    site: window.datadogSettings.site || "datadoghq.com",
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    env: window.datadogSettings.env || "development",
    version: window.datadogSettings.version || "1.0.0",
    service: window.datadogSettings.service || "dockwa-rails",
  })

  // Set user context if available
  if (window.datadogSettings.user) {
    datadogLogs.setUser({
      id: window.datadogSettings.user.id,
      name: window.datadogSettings.user.name,
      email: window.datadogSettings.user.email,
    })
  }
}

export const logger = datadogLogs.logger
